import { render, staticRenderFns } from "./RejectCategoryView.vue?vue&type=template&id=2232c31b"
import script from "./RejectCategoryView.vue?vue&type=script&lang=js"
export * from "./RejectCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports